/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ImgItem from '@/components/ImgItem';
import OrderPrdItem from './OrderPrdItem';
import OrderTop from './OrderTop';
import OrderHandle from './OrderHandle';
export default {
  props: {
    orderObj: {
      type: Object
    }
  },
  components: {
    OrderPrdItem: OrderPrdItem,
    OrderTop: OrderTop,
    OrderHandle: OrderHandle
  },
  computed: {
    orderNo: function orderNo() {
      return this.orderObj.orderNo;
    },
    total: function total() {
      var goods = this.orderObj.goods,
          num = 0;

      var _iterator = _createForOfIteratorHelper(goods),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          num += item.goodsQty;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return num;
    },
    isReal: function isReal() {
      var goods = this.orderObj.goods;

      if (goods.some(function (x) {
        return x.isReal == 0;
      })) {
        return 0;
      } else {
        return 1;
      }
    },
    isUse: function isUse() {
      var goods = this.orderObj.goods;

      if (goods.some(function (x) {
        return x.isUse == 0;
      })) {
        return 0;
      } else {
        return 1;
      }
    }
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {},
  methods: {
    orderHandleDone: function orderHandleDone(status, orderNo, msg) {
      this.$emit('orderHandleDone', status, orderNo, msg);
    },
    goOrderDetail: function goOrderDetail() {
      this.$emit('goOrderDetail', this.orderObj.orderNo); // 
    },
    refundPopShow: function refundPopShow() {
      this.$emit('refundPopShow', this.orderObj);
    }
  }
};